// extracted by mini-css-extract-plugin
export var container = "_tl-0";
export var table = "_tl-2";
export var tableWrapper = "_tl-1";